var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 41.3066L75.0017 0L87.6349 6.95721L27.8045 40.1509L74.9983 66.1422L134.829 32.9519L150 41.3066L75.0017 82.6131L0 41.3066Z",
    fill: "#00D2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 107.19L21.7509 95.4225L34.3841 102.383L27.8045 106.035L74.9983 132.026L134.829 98.8356L150 107.19L75.0017 148.497L0 107.19Z",
    fill: "#016AFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 74.2483L21.7509 62.4839L34.3841 69.4411L27.8045 73.0927L74.9983 99.084L134.829 65.8936L150 74.2483L75.0017 115.555L0 74.2483Z",
    fill: "#03A0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollateLogo);
export default __webpack_public_path__ + "static/media/collate_logo.667ca570040601ed8bd8179cfd378be8.svg";
export { ForwardRef as ReactComponent };